import { BannerList, BannerCreate, BannerEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        BannerList,
        BannerCreate,
        BannerEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'banner',
    icon: 'fa-bullhorn',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Banner/index.ts